const MATERIALS_BY_VOLUME = [
  // ECO
  // izoliacija
  {
    url: "https://www.vedinimas.lt/fpx-15-tr-juosta-st-50x3x15-lipni-sintetinio-kauciuko-izoliacijos-juosta-3mm50mm15m",
    icon: "https://www.vedinimas.lt/images/uploader/fp/269x269.g/fpx-15-tr-juosta-st-50x3x15-lipni-sintetinio-kauciuko-izoliacijos-juosta-3mm50mm15m-1.png?t=28022",
    code: "501000002",
    name: "FPX 15 TR juosta ST 50x3x15; lipni sintetinio kaučiuko izoliacijos juosta 3mm/50mm/15m",
    quantity: 1,
    range: [0, 800],
    productGroup: "normal",
    good_id: 47960,
  },
  //lauko grotos
  {
    url: "https://www.vedinimas.lt/ygav-igc160-lauko-grotos",
    icon: "https://www.vedinimas.lt/images/uploader/yg/500x500.g/ygavigc160-lauko-grotos-1.jpg?t=289087",
    code: "700000003",
    name: "Lauko grotos YGAV 160",
    quantity: 2,
    range: [0, 100],
    productGroup: "normal",
    good_id: 46954,
  },
  {
    url: "https://www.vedinimas.lt/ygav-igc200-lauko-grotos",
    icon: "https://www.vedinimas.lt/images/uploader/yg/500x500.g/ygavigc200-lauko-grotos-1.jpg?t=541186",
    code: "700000004",
    name: "Lauko grotos YGAV 200",
    quantity: 2,
    range: [100, 200],
    productGroup: "normal",
    good_id: 46955,
  },
  {
    url: "https://www.vedinimas.lt/ygav-igc250-lauko-grotos",
    icon: "https://www.vedinimas.lt/images/uploader/yg/500x500.g/ygavigc250-lauko-grotos-1.jpg?t=403232",
    code: "700000005",
    name: "Lauko grotos YGAV 250",
    quantity: 2,
    range: [200, 400],
    productGroup: "normal",
    good_id: 46956,
  },
  {
    url: "https://www.vedinimas.lt/ygav-igc315-lauko-grotos",
    icon: "https://www.vedinimas.lt/images/uploader/yg/500x500.g/ygavigc315-lauko-grotos-1.jpg?t=658893",
    code: "700000006",
    name: "Lauko grotos YGAV 315",
    quantity: 2,
    range: [400, 800],
    productGroup: "normal",
    good_id: 46957,
  },
  // fasonines dalys 1
  {
    url: "https://www.vedinimas.lt/v-is-pereiga-dn-160-125-presuota-su-tarp-vidus-isore",
    icon: "https://www.vedinimas.lt/images/uploader/v_/414x414.g/v-is-pereiga-dn-160125-presuota-su-tarp-vidus-isore-1-1.png?t=45268",
    code: "105101003",
    name: "Pereiga lauko grotoms 160-125 vidus/išorė",
    quantity: 2,
    range: [0, 100],
    productGroup: "normal",
    good_id: 46659,
  },
  {
    url: "https://www.vedinimas.lt/v-is-pereiga-dn-200-160-presuota-su-tarp-vidus-isore",
    icon: "https://www.vedinimas.lt/images/uploader/v_/414x414.g/v-is-pereiga-dn-200160-presuota-su-tarp-vidus-isore-1-1.png?t=700950",
    code: "105101006",
    name: "Pereiga lauko grotoms 200-160 vidus/išorė",
    quantity: 2,
    range: [100, 200],
    productGroup: "normal",
    good_id: 46660,
  },
  {
    url: "https://www.vedinimas.lt/v-is-pereiga-dn-250-200-presuota-su-tarp-vidus-isore",
    icon: "https://www.vedinimas.lt/images/uploader/v_/414x414.g/v-is-pereiga-dn-250200-presuota-su-tarp-vidus-isore-1-1.png?t=161840",
    code: "105101009",
    name: "Pereiga lauko grotoms 250-200 vidus/išorė",
    quantity: 2,
    range: [200, 400],
    productGroup: "normal",
    good_id: 46661,
  },
  {
    url: "https://www.vedinimas.lt/pereiga-dn-315-250-presuota-su-tarp",
    icon: "https://www.vedinimas.lt/images/uploader/pe/417x417.g/pereiga-dn-315250-presuota-su-tarp-1-1.png?t=95798",
    code: "105001012",
    name: "Pereiga lauko grotoms 315-250 vidus/išorė",
    quantity: 2,
    range: [400, 800],
    productGroup: "normal",
    good_id: 46658,
  },
  // slopintuvai
  {
    url: "https://www.vedinimas.lt/lankst-triuksmo-slopintuvas-greendec-25-125mmx10m",
    icon: "https://www.vedinimas.lt/images/uploader/la/588x588.g/lankstus-triuksmo-slopintuvas-green-silver-125-1000-25mm-1.jpg?t=177773",
    code: "301000024",
    name: "Slopintuvas 125 1000 GREEN SILVER 25 Sanitized",
    quantity: 4,
    range: [0, 200],
    productGroup: "normal",
    good_id: 47952,
  },
  {
    url: "https://www.vedinimas.lt/lankst-triuksmo-slopintuvas-greendec-25-160mmx10m",
    icon: "https://www.vedinimas.lt/images/uploader/la/588x588.g/lankstus-triuksmo-slopintuvas-green-silver-125-1000-25mm-1.jpg?t=177773",
    code: "301000025",
    name: "Slopintuvas 160 1000 GREEN SILVER 25 Sanitized",
    quantity: 4,
    range: [200, 350],
    productGroup: "normal",
    good_id: 47953,
  },
  {
    url: "https://www.vedinimas.lt/lankst-triuksmo-slopintuvas-greendec-25-200mmx10m",
    icon: "https://www.vedinimas.lt/images/uploader/la/588x588.g/lankstus-triuksmo-slopintuvas-green-silver-125-1000-25mm-1.jpg?t=177773",
    code: "301000026",
    name: "Slopintuvas 200 1000 GREEN SILVER 25 Sanitized",
    quantity: 4,
    range: [350, 500],
    productGroup: "normal",
    good_id: 47954,
  },
  {
    url: "https://www.vedinimas.lt/green-50-pe2-black-250mmx1-0m-con-dec-2-type-non-woven",
    icon: "https://www.vedinimas.lt/images/uploader/sl/588x588.g/slopintuvas-green-50-pe2-black-250mmx10m-condec-2-type-non-woven-2.jpg?t=186153",
    code: "301000023",
    name: "Slopintuvas 250 1000 GREEN BLACK 50 Sanitized",
    quantity: 4,
    range: [500, 800],
    productGroup: "normal",
    good_id: 46737,
  },
  // lauko ortakiai
  {
    url: "https://www.vedinimas.lt/eps-basic-125-izoliuotas-ortakis",
    icon: "https://www.vedinimas.lt/images/uploader/ep/588x588.g/eps-basic-125-izoliuotas-ortakis-1.png?t=728386",
    code: "114000001",
    name: "Izoliuotas ortakis EPS Basic 125",
    quantity: 5,
    range: [0, 200],
    productGroup: "normal",
    good_id: 47967,
  },
  {
    url: "https://www.vedinimas.lt/eps-basic-125-90-izoliuota-alkune",
    icon: "https://www.vedinimas.lt/images/uploader/ep/588x588.g/eps-basic-125-90-izoliuota-alkune-1-1.png?t=463125",
    code: "114000002",
    name: "Izoliuota alkūnė EPS Basic 125 90",
    quantity: 4,
    range: [0, 200],
    productGroup: "normal",
    good_id: 47968,
  },
  {
    url: "https://www.vedinimas.lt/eps-basic-125-90-izoliuotas-mova",
    icon: "https://www.vedinimas.lt/images/uploader/ep/588x588.g/eps-basic-125-izoliuota-mova-1.png?t=420212",
    code: "114000003",
    name: "Izoliuota mova EPS Basic 125",
    quantity: 10,
    range: [0, 200],
    productGroup: "normal",
    good_id: 47969,
  },
  {
    url: "https://www.vedinimas.lt/eps-basic-160-izoliuotas-ortakis",
    icon: "https://www.vedinimas.lt/images/uploader/ep/588x588.g/eps-basic-160-izoliuotas-ortakis-1.png?t=592051",
    code: "114000004",
    name: "Izoliuotas ortakis EPS Basic 160",
    quantity: 5,
    range: [200, 350],
    productGroup: "normal",
    good_id: 47970,
  },
  {
    url: "https://www.vedinimas.lt/eps-basic-160-90-izoliuota-alkune",
    icon: "https://www.vedinimas.lt/images/uploader/ep/588x588.g/eps-basic-160-90-izoliuota-alkune-1.png?t=145605",
    code: "114000005",
    name: "Izoliuota alkūnė EPS Basic 160 90",
    quantity: 4,
    range: [200, 350],
    productGroup: "normal",
    good_id: 47971,
  },
  {
    url: "https://www.vedinimas.lt/eps-basic-160-90-izoliuotas-mova",
    icon: "https://www.vedinimas.lt/images/uploader/ep/588x588.g/eps-basic-160-izoliuota-mova-1.png?t=324203",
    code: "114000006",
    name: "Izoliuota mova EPS Basic 160",
    quantity: 10,
    range: [200, 350],
    productGroup: "normal",
    good_id: 47972,
  },
  {
    url: "https://www.vedinimas.lt/epp-200-izoliuotas-ortakis-zehnder-l1000mm-d230-200mm",
    icon: "https://www.vedinimas.lt/images/uploader/ep/500x500.g/epp-200-izoliuotas-ortakis-zehnder-l1000mm-d230200mm-1.jpg?t=676072",
    code: "990328696",
    name: "EPP 200 Zehnder izoliuotas ortakis",
    quantity: 5,
    range: [350, 800],
    productGroup: "normal",
    good_id: 47003,
  },
  {
    url: "https://www.vedinimas.lt/epp-200-45-izoliuota-alkune-zehnder-d230-200mm",
    icon: "https://www.vedinimas.lt/images/uploader/ep/500x500.g/epp-200-45-izoliuota-alkune-zehnder-d230200mm-1.jpg?t=714316",
    code: "990328697",
    name: "EPP 200 45 Zehnder izoliuota alkūnė",
    quantity: 6,
    range: [350, 800],
    productGroup: "normal",
    good_id: 47004,
  },
  {
    url: "https://www.vedinimas.lt/epp-mova-200-vid-vid-con-cpcp-dn200m-izoliuota-zehnder",
    icon: "https://www.vedinimas.lt/images/uploader/ep/500x500.g/epp-mova-200-vid-vid-con-cpcp-dn200m-izoliuota-zehnder-1.jpg?t=748274",
    code: "990328762",
    name: "EPP 200 Zehnder izoliuota mova",
    quantity: 2,
    range: [350, 800],
    productGroup: "normal",
    good_id: 47007,
  },
  // fasonines dalys 2
  {
    url: "https://www.vedinimas.lt/mova-dn125-su-tarpine",
    icon: "https://www.vedinimas.lt/images/uploader/mo/406x406.g/mova-dn125-su-tarpine-1-1.png?t=125852",
    code: "102001002",
    name: "Mova skardinė 125",
    quantity: 4,
    range: [0, 200],
    productGroup: "normal",
    good_id: 46624,
  },
  {
    url: "https://www.vedinimas.lt/mova-dn160-su-tarpine",
    icon: "https://www.vedinimas.lt/images/uploader/mo/406x406.g/mova-dn160-su-tarpine-1-1.png?t=703840",
    code: "102001003",
    name: "Mova skardinė 160",
    quantity: 4,
    range: [200, 350],
    productGroup: "normal",
    good_id: 46625,
  },
  {
    url: "https://www.vedinimas.lt/mova-dn200-su-tarpine",
    icon: "https://www.vedinimas.lt/images/uploader/mo/406x406.g/mova-dn200-su-tarpine-1-1.png?t=51483",
    code: "102001004",
    name: "Mova skardinė 200",
    quantity: 4,
    range: [350, 500],
    productGroup: "normal",
    good_id: 46626,
  },
  {
    url: "https://www.vedinimas.lt/mova-dn250-su-tarpine",
    icon: "https://www.vedinimas.lt/images/uploader/mo/406x406.g/mova-dn250-su-tarpine-1-1.png?t=513561",
    code: "102001005",
    name: "Mova skardinė 250",
    quantity: 4,
    range: [500, 800],
    productGroup: "normal",
    good_id: 46627,
  },
  // PREMIUM
  // izoliacija
  {
    url: "https://www.vedinimas.lt/fpx-15-tr-juosta-st-50x3x15-lipni-sintetinio-kauciuko-izoliacijos-juosta-3mm50mm15m",
    icon: "https://www.vedinimas.lt/images/uploader/fp/269x269.g/fpx-15-tr-juosta-st-50x3x15-lipni-sintetinio-kauciuko-izoliacijos-juosta-3mm50mm15m-1.png?t=28022",
    code: "501000002",
    name: "FPX 15 TR juosta ST 50x3x15; lipni sintetinio kaučiuko izoliacijos juosta 3mm/50mm/15m",
    quantity: 1,
    range: [0, 800],
    productGroup: "premium",
    good_id: 47960,
  },
  //lauko grotos
  {
    url: "https://www.vedinimas.lt/lauko-grotos-nosl-125-9005-juodos",
    icon: "https://www.vedinimas.lt/images/uploader/la/1036x1036.g/lauko-grotos-nosl-125-9005-juodos-2-1.png?v=1761214981",
    code: "703000125",
    name: "Lauko grotos Nosl 125",
    quantity: 2,
    range: [0, 150],
    productGroup: "premium",
    good_id: 47339,
  },
  {
    url: "https://www.vedinimas.lt/lauko-grotos-nosl-160-9005-juodos",
    icon: "https://www.vedinimas.lt/images/uploader/la/588x588.g/lauko-grotos-nosl-160-9005-juodos-9-1.jpg?t=261655",
    code: "703000160",
    name: "Lauko grotos Nosl 160",
    quantity: 2,
    range: [150, 250],
    productGroup: "premium",
    good_id: 47340,
  },
  {
    url: "https://www.vedinimas.lt/lauko-grotos-nosl-200-9005-juodos",
    icon: "https://www.vedinimas.lt/images/uploader/la/588x588.g/lauko-grotos-nosl-200-9005-juodos-8-1.jpg?t=730026",
    code: "703000200",
    name: "Lauko grotos Nosl 200",
    quantity: 2,
    range: [250, 450],
    productGroup: "premium",
    good_id: 47341,
  },
  {
    url: "https://www.vedinimas.lt/lauko-grotos-nosl-250-9005-juodos",
    icon: "https://www.vedinimas.lt/images/uploader/la/588x588.g/lauko-grotos-nosl-250-9005-juodos-9-1.jpg?t=463077",
    code: "703000250",
    name: "Lauko grotos Nosl 250",
    quantity: 2,
    range: [450, 600],
    productGroup: "premium",
    good_id: 47342,
  },
  {
    url: "https://www.vedinimas.lt/lauko-grotos-nosl-250-9005-juodos-1",
    icon: "https://www.vedinimas.lt/images/uploader/la/588x588.g/lauko-grotos-nosl-315-9005-juodos-8-1.jpg?t=536609",
    code: "703000315",
    name: "Lauko grotos Nosl 315",
    quantity: 2,
    range: [600, 800],
    productGroup: "premium",
    good_id: 47343,
  },
  // slopintuvai
  {
    url: "https://www.vedinimas.lt/green-50-pe2-black-125mmx1-0m-con-dec-2-type-non-woven",
    icon: "https://www.vedinimas.lt/images/uploader/sl/588x588.g/slopintuvas-green-50-pe2-black-125mmx10m-condec-2-type-non-woven-2-1.jpg?t=496742",
    code: "301000020",
    name: "Slopintuvas 125 1000 GREEN BLACK 50 Sanitized",
    quantity: 4,
    range: [0, 200],
    productGroup: "premium",
    good_id: 46734,
  },
  {
    url: "https://www.vedinimas.lt/green-50-pe2-black-160mmx1-0m-con-dec-2-type-non-woven",
    icon: "https://www.vedinimas.lt/images/uploader/sl/588x588.g/slopintuvas-green-50-pe2-black-160mmx10m-condec-2-type-non-woven-1-1.jpg?t=566859",
    code: "301000021",
    name: "Slopintuvas 160 1000 GREEN BLACK 50 Sanitized",
    quantity: 4,
    range: [200, 350],
    productGroup: "premium",
    good_id: 46735,
  },
  {
    url: "https://www.vedinimas.lt/green-50-pe2-black-200mmx1-0m-con-dec-2-type-non-woven",
    icon: "https://www.vedinimas.lt/images/uploader/sl/588x588.g/slopintuvas-green-50-pe2-black-200mmx10m-condec-2-type-non-woven-2.jpg?t=633994",
    code: "301000022",
    name: "Slopintuvas 200 1000 GREEN BLACK 50 Sanitized",
    quantity: 4,
    range: [350, 500],
    productGroup: "premium",
    good_id: 46736,
  },
  {
    url: "https://www.vedinimas.lt/green-50-pe2-black-250mmx1-0m-con-dec-2-type-non-woven",
    icon: "https://www.vedinimas.lt/images/uploader/sl/588x588.g/slopintuvas-green-50-pe2-black-250mmx10m-condec-2-type-non-woven-2.jpg?t=705211",
    code: "301000023",
    name: "Slopintuvas 250 1000 GREEN BLACK 50 Sanitized",
    quantity: 4,
    range: [500, 800],
    productGroup: "premium",
    good_id: 46737,
  },
  // lauko ortakiai
  {
    url: "https://www.vedinimas.lt/epp-125-izoliuotas-ortakis-zehnder-l1000mm-d155-125mm",
    icon: "https://www.vedinimas.lt/images/uploader/ep/500x500.g/epp-125-izoliuotas-ortakis-zehnder-l1000mm-d155125mm-1.jpg?t=415048",
    code: "990328690",
    name: "EPP 125 Zehnder izoliuotas ortakis",
    quantity: 5,
    range: [0, 200],
    productGroup: "premium",
    good_id: 46999,
  },
  {
    url: "https://www.vedinimas.lt/epp-125-45-izoliuota-alkune-zehnder-d155-125mm",
    icon: "https://www.vedinimas.lt/images/uploader/ep/500x500.g/epp-125-45-izoliuota-alkune-zehnder-d155125mm-1.jpg?t=724509",
    code: "990328691",
    name: "EPP 125 45 Zehnder izoliuota alkūnė",
    quantity: 6,
    range: [0, 200],
    productGroup: "premium",
    good_id: 47000,
  },
  {
    url: "https://www.vedinimas.lt/epp-mova-125-vid-vid-con-cpcp-dn125-m-izoliuota-zehnder",
    icon: "https://www.vedinimas.lt/images/uploader/ep/500x500.g/epp-mova-125-vid-vid-con-cpcp-dn125-m-izoliuota-zehnder-1.jpg?t=453570",
    code: "990328760",
    name: "EPP 125 Zehnder izoliuota mova",
    quantity: 2,
    range: [0, 200],
    productGroup: "premium",
    good_id: 47005,
  },
  {
    url: "https://www.vedinimas.lt/epp-160-izoliuotas-ortakis-zehnder-l1000mm-d190-160mm",
    icon: "https://www.vedinimas.lt/images/uploader/ep/500x500.g/epp-160-izoliuotas-ortakis-zehnder-l1000mm-d190160mm-1.jpg?t=5046",
    code: "990328693",
    name: "EPP 160 Zehnder izoliuotas ortakis",
    quantity: 5,
    range: [200, 350],
    productGroup: "premium",
    good_id: 47001,
  },
  {
    url: "https://www.vedinimas.lt/epp-160-45-izoliuota-alkune-zehnder-d190-160mm",
    icon: "https://www.vedinimas.lt/images/uploader/ep/500x500.g/epp-160-45-izoliuota-alkune-zehnder-d190160mm-1.jpg?t=186990",
    code: "990328694",
    name: "EPP 160 45 Zehnder izoliuota alkūnė",
    quantity: 6,
    range: [200, 350],
    productGroup: "premium",
    good_id: 47002,
  },
  {
    url: "https://www.vedinimas.lt/epp-mova-160-vid-vid-con-cpcp-dn160-m-izoliuota-zehnder",
    icon: "https://www.vedinimas.lt/images/uploader/ep/500x500.g/epp-mova-160-vid-vid-con-cpcp-dn160-m-izoliuota-zehnder-1.jpg?t=143833",
    code: "990328761",
    name: "EPP 160 Zehnder izoliuota mova",
    quantity: 2,
    range: [200, 350],
    productGroup: "premium",
    good_id: 47006,
  },
  {
    url: "https://www.vedinimas.lt/epp-200-izoliuotas-ortakis-zehnder-l1000mm-d230-200mm",
    icon: "https://www.vedinimas.lt/images/uploader/ep/500x500.g/epp-200-izoliuotas-ortakis-zehnder-l1000mm-d230200mm-1.jpg?t=516204",
    code: "990328696",
    name: "EPP 200 Zehnder izoliuotas ortakis",
    quantity: 5,
    range: [350, 800],
    productGroup: "premium",
    good_id: 47003,
  },
  {
    url: "https://www.vedinimas.lt/epp-200-45-izoliuota-alkune-zehnder-d230-200mm",
    icon: "https://www.vedinimas.lt/images/uploader/ep/500x500.g/epp-200-45-izoliuota-alkune-zehnder-d230200mm-1.jpg?t=798704",
    code: "990328697",
    name: "EPP 200 45 Zehnder izoliuota alkūnė",
    quantity: 6,
    range: [350, 800],
    productGroup: "premium",
    good_id: 47004,
  },
  {
    url: "https://www.vedinimas.lt/epp-mova-200-vid-vid-con-cpcp-dn200m-izoliuota-zehnder",
    icon: "https://www.vedinimas.lt/images/uploader/ep/500x500.g/epp-mova-200-vid-vid-con-cpcp-dn200m-izoliuota-zehnder-1.jpg?t=349936",
    code: "990328762",
    name: "EPP 200 Zehnder izoliuota mova",
    quantity: 2,
    range: [350, 800],
    productGroup: "premium",
    good_id: 47007,
  },
  // fasonines dalys
  {
    url: "https://www.vedinimas.lt/mova-dn125-su-tarpine",
    icon: "https://www.vedinimas.lt/images/uploader/mo/406x406.g/mova-dn125-su-tarpine-1-1.png?t=125852",
    code: "102001002",
    name: "Mova skardinė 125",
    quantity: 4,
    range: [0, 200],
    productGroup: "premium",
    good_id: 46624,
  },
  {
    url: "https://www.vedinimas.lt/mova-dn160-su-tarpine",
    icon: "https://www.vedinimas.lt/images/uploader/mo/406x406.g/mova-dn160-su-tarpine-1-1.png?t=703840",
    code: "102001003",
    name: "Mova skardinė 160",
    quantity: 4,
    range: [200, 350],
    productGroup: "premium",
    good_id: 46625,
  },
  {
    url: "https://www.vedinimas.lt/mova-dn200-su-tarpine",
    icon: "https://www.vedinimas.lt/images/uploader/mo/406x406.g/mova-dn200-su-tarpine-1-1.png?t=51483",
    code: "102001004",
    name: "Mova skardinė 200",
    quantity: 4,
    range: [350, 500],
    productGroup: "premium",
    good_id: 46626,
  },
  {
    url: "https://www.vedinimas.lt/mova-dn250-su-tarpine",
    icon: "https://www.vedinimas.lt/images/uploader/mo/406x406.g/mova-dn250-su-tarpine-1-1.png?t=513561",
    code: "102001005",
    name: "Mova skardinė 250",
    quantity: 4,
    range: [500, 800],
    productGroup: "premium",
    good_id: 46627,
  }
];

export default MATERIALS_BY_VOLUME;
